import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import AgentCreate from "./AgentCreate";
import AgentImportModal from "./AgentImportModal";
import CommonCallBackButton from "../Common/CommonCallBackButton";

// icons
import DeleteIcon from "@mui/icons-material/Delete";


class AgentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            agents: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveAgents();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveAgents();
        }
    }

    async retrieveAgents() {
        const url = 'agent/';
        const api = new BaseApi();
        let params = {
            archived: false
        }
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                agents: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    async delete(id) {
        const url = `agent/${id}/`;
        const api = new BaseApi();
        await api.delete(url);
        await this.retrieveAgents()
    }

    render() {
        if (!this.state.agents) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Агенты'}
                    url={'agent'}
                    data={this.state.agents}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    extraComponents={[
                        {
                            component: AgentCreate,
                            componentProps: {
                                root: true,
                            },
                        },
                        {
                            component: AgentImportModal,
                            componentProps: {},
                        }
                    ]}
                    callBack={this.retrieveAgents.bind(this)}
                    fields={[
                        {
                            title: 'Полное название',
                            name: 'title',
                            linkPattern: '/agent/detail/:linkParam',
                            linkParam: 'id',
                            visible: true,
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: DeleteIcon,
                                color: 'danger',
                            },
                            callBack: this.delete.bind(this),
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(AgentList)